import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { GoogleAnalyticsService } from '../app/services/google_analytics/google-analytics.service';
import { environment } from '../environments/environment';
import { NonceService } from './services/nonce.service';
// import { UserIdleService } from 'angular-user-idle';
declare let ga: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'app';
  message = 'Welcome to app!';
  nonce: string = '';
  trackingID = environment.analyticsID;
  ComplaintsTrackingID = environment.ComplaintsTrackingID;
  constructor(public router: Router,
    public googleAnalyticsService: GoogleAnalyticsService,
    private nonceService: NonceService) {
    this.appendGaTrackingCode();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if((event.urlAfterRedirects === "/par/managecomplaints") || (event.urlAfterRedirects === "/par/regionstatemapping")){
          ga('CompliantsTracker.set', 'page', event.urlAfterRedirects);
          ga('CompliantsTracker.send', 'pageview');
        } else {
          ga('set', 'page', event.urlAfterRedirects);
          ga('send', 'pageview');
        }
      }
    });
  }
  ngOnInit(): void {
    this.nonce = this.nonceService.getNonce();
  }
  private appendGaTrackingCode() {
    try {
      const script = document.createElement('script');
      script.setAttribute('nonce',this.nonce);
      script.innerHTML = `
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

        ga('create', '${this.trackingID}', 'auto');
        ga('create', '${this.ComplaintsTrackingID}', 'auto', 'CompliantsTracker')
       
      `;
      document.head.appendChild(script);
    } catch (ex) {
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts